import React from "react";
import { BadgeProps, BadgeIndigo } from "./Badge";

export const FullDutyBadge = (props: BadgeProps): React.ReactElement => (
  <BadgeIndigo {...props} icon={"CURRENCY_GBP"}>
    Full-duty requested
  </BadgeIndigo>
);
